export default {
  content: {
    marginBottom: 20,
    // TODO: Revert after demo
    fontSize: 0,
    color: '#757575',
  },
};
